module.exports = __webpack_public_path__ + "img/lasers.eb6c4c07.png";